import Link from "next/link";
import { buttonVariants } from "../ui/button";

type Status = 401 | 403 | 404 | 429 | 500 | 502 | 503 | 504;

export default function ErrorPage({ status }: { status: Status }) {
	const title = {
		401: "Unauthorized",
		403: "Forbidden",
		404: "Page not found",
		429: "Too many requests",
		500: "Server error",
		502: "Bad gateway",
		503: "Service unavailable",
		504: "Gateway timeout",
	}[status];

	const description = {
		401: "You need to be authenticated to access this page. Please sign in and try again.",
		403: "You don’t have permission to access this page. If you think this is a mistake, please contact support.",
		404: "We’re sorry, but the page you’re looking for doesn’t exist. It might have been moved or removed.",
		429: "You’ve sent too many requests in a short time. Please wait a moment and try again.",
		500: "Something went wrong on our side. Please refresh the page or try again shortly.",
		502: "We received an invalid response from an upstream server. Please try again later.",
		503: "We’re performing scheduled maintenance right now. Please try again in a few minutes.",
		504: "The server took too long to respond. Please try again in a moment.",
	}[status];
	const meta = { description, title };
	return (
		<main className="grid min-h-screen place-items-center bg-bg px-4 py-24 sm:py-32 lg:px-8">
			<div className="text-center">
				<h1 className="font-semibold text-8xl text-fg tabular-nums tracking-wider">{status}</h1>
				<h2 className="mt-4 font-display font-medium text-xl/7">{meta.title}</h2>
				<p className="mt-3 max-w-sm text-pretty">{meta.description}</p>
				{status !== 500 && (
					<div className="mt-6 flex items-center justify-center gap-x-2">
						<Link className={buttonVariants({ size: "lg", variant: "secondary" })} href="/">
							Return to home
						</Link>
					</div>
				)}
			</div>
		</main>
	);
}
